<template>
  <div class="new-dialog">
    <el-dialog title="修改手机号" :visible.sync="visible" width="480px" top="calc((100vh - 300px) / 2)" :close-on-click-modal="false" :before-close="closeDialog">
      <div class="steps-nav">
        <ul class="steps">
          <li v-for="(item,index) in setData" :key="index" :class="{'active':Steps===index}">
            <div class="steps-content">{{item.name}}</div>
          </li>
        </ul>
      </div>
      <div class="step1" v-if="Steps === 0">
        <div class="form">
          <el-form ref="form" style="margin-top: 20px;" class="login-from" :model="formData" :rules="bindCheck" label-width="80px" validate>
            <el-form-item label="手机号" prop="phone">
              <el-input size="small" v-model="formData.phone" autofocus placeholder="手机号">
                <template slot="prepend">+86</template>
              </el-input>
            </el-form-item>
            <el-row :gutter="12">
              <el-col :span="15">
                <el-form-item label="验证码" prop="verifyCode">
                  <el-input size="small" v-model="formData.verifyCode" autofocus placeholder="短信验证码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-button v-if="!codeSend && !codeIsSend" type="info" size="small" style="width: 100%;">获取验证码</el-button>
                <el-button v-else-if="codeSend && !codeIsSend" type="primary" size="small" style=" width: 100%;" @click="showCode">获取验证码</el-button>
                <el-button v-else-if="codeIsSend" type="info" size="small" disabled style="width: 100%;">{{count}}秒后重新发送</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <!-- 输入图形验证码 -->
        <div class="showModal" v-if="showVerCode">
          <div class="modal-body">
            <div class="demo-modal-header">
              <div class="drawerHead">
                <span class="inner">输入验证码</span>
                <div class="demo-top-close">
                  <Icon type="ios-close" size="34" @click="closeVerModal" />
                </div>
              </div>
            </div>
            <div class="verCon">
              <img id="verImg" :src="imgVer.codeImg" width="130px" height="48px" />
              <div style="display: flex; flex-direction: row; width: 300px; margin: 0 auto;">
                <div style="width: 250px;">
                  <el-input :value="imgVer.verifyCode" @input="changeCode" @change="enterCode" placeholder="输入验证码"></el-input>
                </div>
                <el-button style="margin-left: 6px;" @click="showCode"><i class="el-icon-refresh"></i></el-button>
              </div>
              <el-button type="primary" :loading="submiting" style="height: 42px; width: 300px; margin-top: 16px;" @click="enterCode">
                <span v-if="!submiting">提交验证</span>
                <span v-else>请稍后...</span>
              </el-button>
              <div style="height: 30px;">
                <div style="line-height: 30px; color: red;">{{errorCode}}</div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog()">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmitstep(1)">下一步</el-button>
        </span>
      </div>
      <div class="step1" v-if="Steps == 1">
        <div style="margin: 32px 0">
          <el-form ref="form" style="margin-top: 20px;" class="login-from" :model="formData" :rules="bindCheck" label-width="80px" validate>
            <el-form-item label="新手机号" prop="newPhone">
              <el-input size="small" v-model="formData.newPhone" autofocus placeholder="新手机号">
                <template slot="prepend">+86</template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" type="text" @click="Steps = 0">上一步</el-button>
          <el-button size="small" type="primary" @click="onSubmitstep(2)">下一步</el-button>
        </span>
      </div>
      <div class="step2" v-if="Steps == 2">
        <div class="success">
          <el-result icon="success" title="修改成功～" subTitle=""></el-result>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" @click="onSubmitstep()">完成</el-button>
        </span>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax";
const rulePhone = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;// 手机号码校验规则
export default {
  name: "phone",
  props: {
    visible: Boolean,
  },
  data(){
    const phoneValidate = async(rule, value, callback) => {
      if (!value || value.length < 1) {
        this.codeSend = false;
        return callback(new Error('手机号码不能为空'));
      } else if (!rulePhone.test(value)) {
        this.codeSend = false;
        return callback(new Error('手机号码格式不正确'));
      } else{
        this.codeSend = true;
        callback();
      }
    };
    return{
      count:0,
      Steps:0,
      loading:false,
      codeIsSend: false,
      showVerCode:false,
      submiting:false,
      codeSend:false,
      errorCode: '',
      formData:{
        phone:'',
        newPhone:''
      },
      newPhone:'',
      setData:[{name:'验证身份'},{name:'填写新手机'},{name:'修改完成'}],
      bindCheck:{
        phone: [{ required: true, validator: phoneValidate, trigger: "change" }],
        verifyCode: [{ required: true, message: '请输入短信验证码', trigger: 'change' }],
        newPhone: [{ required: true, validator: phoneValidate, trigger: "change" }],
      },
      imgVer: {
        codeImg: '',
        key: '',
        verifyCode: '',
      },
    }
  },
  methods:{
    // 下一步
    onSubmitstep(num) {
      if(num == 1){
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.Steps = 1
            setTimeout(()=>{
              this.$refs['form'].clearValidate('newPhone');
            },10)
          }
        });
      }else if(num == 2){
        let params = {
          newPhone:this.formData.newPhone,
          verifyCode:this.formData.verifyCode
        }
        httpAjax({
          url:'/services/user/changePhone',
          method:'post',
          data: params
        }).then((response) => {
          if(response.success) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.Steps = 2
          } else {
            this.$message({
              message: response.msg,
              type: 'error'
            })
          }
        });
      }else{
        this.closeDialog()
      }
    },
    // 显示验证码
    showCode() {
      if(this.formData.phone === ''){
        this.$message({
          message: '请输入手机号',
          type: 'error'
        })
        return;
      }
      httpAjax({
        url: '/services/verify/captcha',
        method: "get",
      }).then((response) => {
        if (response.success) {
          this.imgVer.codeImg = response.data.image;
          this.imgVer.key = response.data.key;
          this.showVerCode = true;
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      });
    },

    // 提交验证码
    enterCode() {
      if (this.imgVer.verifyCode === '') {
        this.errorCode = '请输入验证码';
        return;
      }
      this.submiting = true;
      httpAjax({
        url: '/services/verify/send/verifySms',
        method: "get",
        data: {
          key: this.imgVer.key,
          phoneNumber: this.formData.phone,
          verifyCode: this.imgVer.verifyCode,
          type: 'up'
        }
      }).then((response) => {
        if (response.success) {
          this.closeVerModal();
          this.codeIsSend = true;
          this.count = 60;
          this.timeFun();
        } else {
          this.errorCode = response.msg;
        }
        this.submiting = false;
      });
    },

    // 倒计时
    timeFun() {
      this.count = 60;
      this.timer = setInterval(() => {
        if(this.count === 1) {
          this.codeIsSend = false;
          clearInterval(this.timer);
        } else {
          this.count--;
        }
      }, 1000);
    },

    // 输入验证码
    changeCode(value) {
      this.imgVer.verifyCode = value;
    },
    // 关闭验证码
    closeVerModal() {
      this.showVerCode = false;
      this.imgVer.verifyCode = '';
      this.errorCode = '';
    },
    //  关闭
    closeDialog(){
      this.$parent.phoneVisible = false
      this.$parent.getCurrentCompany()
    }

  }
}
</script>

<style scoped lang="less">
.showModal {
  width: 480px !important;
}

.steps-nav {
  display: flex;
  justify-content: center;
}
.step1 {
  text-align: center;
  .company-name {
    padding: 32px;
  }
}
.step2 {
  text-align: center;
  .success {
    padding: 30px;
  }
}
</style>